import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import IdentityApiService from 'Service/Identity/IdentityApiService';
import OrderManagementApiService from './OrderManagementApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_APPROVERS_LIST, GET_CURRENT_OOO_SETTINGS, GET_CURRENT_OOO_SETTINGS_PROFILE, GET_VALIDATE_BACKUP_APPROVER, SAVE_OUT_OF_OFFICE_SETTING, SAVE_OUT_OF_OFFICE_SETTING_PROFILE } from 'Store/OrderManagement/OutOfOffice/OutOfOfficeTypes';
import { setIsOutOfOfficeSaved, setApproversList, setCurrentSettings, setCurrentSettingsProfile, setIsOutOfOfficeSavedProfile, setValidateBackUpApprover } from 'Store/OrderManagement/OutOfOffice/OutOfOfficeActions';

function* getApproversList(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Approvers...."));
        let payloadData : IPayload = {
            apiType : apiType.Identity,
            endpoint :  `users/approvalusers/title?searchText=${req.payload.emailId}&isPrimaryApprover=${req.payload.isPrimaryApprover}`,
            apiMethod :  apiMethod.GET,
            payload : null
            
           }
        const response = yield call(
            IdentityApiService.post,API_URL.PostWebApp,payloadData
           
        );

        if (response) {
            yield put(setApproversList({
                isPrimaryApprover: req.payload.isPrimaryApprover,
                response : response
            }));
        }
        
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setApproversList([]))
        yield put(globalLoaderText(""));
    }
}

function* saveOutOfOfficeSetting(req: any): any {
    try {
        yield put(globalLoaderText("Saving Approver Override...."));
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint :  `outofoffice`,
            apiMethod :  apiMethod.POST,
            payload : req.payload
            
           }
        const response = yield call(
            OrderManagementApiService.post,API_URL.PostWebApp,payloadData
        );

        if (response) {
            yield put(setIsOutOfOfficeSaved(response));
        }
        
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsOutOfOfficeSaved(false))
        yield put(globalLoaderText(""));
    }
}

function* saveOutOfOfficeSettingProfile(req: any): any {
    try {
        yield put(globalLoaderText("Saving Approver Override...."));
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint :  `outofoffice`,
            apiMethod :  apiMethod.POST,
            payload : req.payload
            
           }
        const response = yield call(
            OrderManagementApiService.post,API_URL.PostWebApp,payloadData
        );

        if (response) {
            yield put(setIsOutOfOfficeSavedProfile(response));
        }
        
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsOutOfOfficeSavedProfile(false))
        yield put(globalLoaderText(""));
    }
}

function* getCurrentSettings(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Current Setting...."));
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint :  `outofoffice/${req.payload}`,
            apiMethod :  apiMethod.GET,
            payload : null
            
           }
        const response = yield call(
            OrderManagementApiService.post,API_URL.PostWebApp,payloadData
        );

        if (response) {
            yield put(setCurrentSettings(response));
        } else {
            yield put(setCurrentSettings({}))
        }
        
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCurrentSettings({}))
        yield put(globalLoaderText(""));
    }
}

function* getCurrentSettingsProfile(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Current Setting...."));
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint :  `outofoffice/${req.payload}`,
            apiMethod :  apiMethod.GET,
            payload : null
            
           }
        const response = yield call(
            OrderManagementApiService.post,API_URL.PostWebApp,payloadData
        );

        if (response) {
            yield put(setCurrentSettingsProfile(response));
        }else {
            yield put(setCurrentSettingsProfile({}))
        }
        
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCurrentSettingsProfile({}))
        yield put(globalLoaderText(""));
    }
}

function* validateOOOSettingSaga(req: any): any {
    try {
        yield put(globalLoaderText("Validating BackUp Approver ...."));
        let payloadData : IPayload = {
            apiType : apiType.OrderManagement,
            endpoint :  `outofoffice/validate/backUpApprover`,
            apiMethod :  apiMethod.POST,
            payload : req.payload
            
           }
        const response = yield call(
            OrderManagementApiService.post,API_URL.PostWebApp,payloadData
        );

        if (response) {
            yield put(setValidateBackUpApprover({response: response, page: req?.page}));
        }
        
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setValidateBackUpApprover({
            isValid : false,
            message : "Something went wrong while validating"
        }))
        yield put(globalLoaderText(""));
    }
}

function* watchOutOfOffice() {
    yield takeEvery(GET_APPROVERS_LIST, getApproversList);
    yield takeEvery(SAVE_OUT_OF_OFFICE_SETTING, saveOutOfOfficeSetting);
    yield takeEvery(GET_CURRENT_OOO_SETTINGS, getCurrentSettings);
    yield takeEvery(GET_CURRENT_OOO_SETTINGS_PROFILE, getCurrentSettingsProfile);
    yield takeEvery(SAVE_OUT_OF_OFFICE_SETTING_PROFILE, saveOutOfOfficeSettingProfile);
    yield takeEvery(GET_VALIDATE_BACKUP_APPROVER, validateOOOSettingSaga)
}

export default function* combinedSaga() {
    yield all([
        watchOutOfOffice()
    ])
}